import { FC, HTMLAttributes, PropsWithChildren, ReactNode } from 'react'
import {
  SummaryCard,
  SummaryCardText,
  SummaryLabel,
  SummaryUnits,
  SummaryValue
} from './BudgetSummaryCard.styles.ts'
import { numberWithSpaces } from '../../shared/utils/formats.ts'

interface Props extends HTMLAttributes<HTMLDivElement> {
  value: number
  label: ReactNode
  units?: ReactNode
}

export const BudgetSummaryCard: FC<PropsWithChildren<Props>> = ({
  value,
  label,
  units,
  children,
  ...props
}) => (
  <SummaryCard {...props}>
    <SummaryCardText>
      <SummaryLabel>{label}</SummaryLabel>
      <SummaryValue>{numberWithSpaces(value)}</SummaryValue>
      <SummaryUnits>{units}</SummaryUnits>
      {children}
    </SummaryCardText>
  </SummaryCard>
)
